export default __webpack_public_path__ + "static/media/img_lanmu.a43eef6d.png";